// removed by extract-text-webpack-plugin
module.exports = {"inputStock":"InputStock__inputStock____vV1h shared__inputNumberAsText___1Qr9M","inputStockAntiguo":"InputStock__inputStockAntiguo___2K_bo shared__inputNumberAsText___1Qr9M","inputStockDirty":"InputStock__inputStockDirty___35yPF InputStock__inputStock____vV1h shared__inputNumberAsText___1Qr9M","inputStockInvalida":"InputStock__inputStockInvalida___4u772 InputStock__inputStock____vV1h shared__inputNumberAsText___1Qr9M","divConTooltip":"InputStock__divConTooltip___1cT0B","tooltip":"InputStock__tooltip___1XvQD"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/components/shared/InputStock.css
// module id = 636
// module chunks = 0